import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import StorageMeter from "@/components/StorageMeter";

export default function ClientDashboard() {
  const [projects, setProjects] = useState([]);
  const [storage, setStorage] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const [pr, st] = await Promise.all([
          api.get("/client/projects"),
          api.get("/client/storage").catch(() => ({ data: null })),
        ]);
        setProjects(pr.data);
        setStorage(st.data);
      } catch (e) { toast.error(apiErrorMessage(e)); }
    })();
  }, []);
  return (
    <div className="px-8 py-8 max-w-7xl">
      <div className="text-[11px] uppercase tracking-[0.3em] text-zinc-500">Portal</div>
      <h1 className="font-display text-4xl tracking-tight mt-1 mb-8">Your projects</h1>
      {storage && storage.limit_bytes > 0 && (
        <div className="mb-8 max-w-md">
          <StorageMeter data={storage} testid="client-storage-meter" />
        </div>
      )}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {projects.length === 0 && <div className="text-sm text-zinc-500" data-testid="empty-client-projects">No projects assigned yet.</div>}
        {projects.map(p => (
          <Link key={p.id} to={`/portal/projects/${p.id}`} className="rounded-xl border border-zinc-200 bg-white overflow-hidden group" data-testid={`portal-project-${p.id}`}>
            <div className="aspect-[16/9] bg-zinc-100">
              {p.cover_url && <img src={p.cover_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />}
            </div>
            <div className="p-4 flex items-center justify-between">
              <div>
                <div className="font-display text-lg">{p.name}</div>
                <div className="text-xs text-zinc-500 mt-0.5">/{p.slug}</div>
              </div>
              <ArrowRight className="h-4 w-4 text-zinc-400 group-hover:translate-x-0.5 transition" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
